module.exports = __webpack_public_path__ + "static/media/person.f5aa5cf1.svg";